import React, { useEffect, useState } from "react";
import { RouteComponentProps, Redirect } from "react-router-dom";
import { Loading } from "@alm/flow-ds/components";
import api from "lib/api";
import DashboardLayout from "components/Layouts/DashboardLayout";

type Props = RouteComponentProps<{ id: string }>;

function NewActivityRoute(props: Props) {
	const [tid, setTid] = useState(null);

	useEffect(() => {
		api.workflow.start(props.match.params.id).then(res => {
			const { id } = res.data.data[0];
			setTid(id);
		});
	}, [props.match.params.id]);

	return (
		<DashboardLayout>
			{tid === null ? (
				<Loading className="elem__loader--lg mt-5" />
			) : (
				<Redirect to={`/task/${tid}`} />
			)}
		</DashboardLayout>
	);
}

export default NewActivityRoute;
